import { PaymentIntentPayload } from '../../../types/orders.type';
import { sfcApi } from '../../api';

export const stripeApi = sfcApi.injectEndpoints({
  endpoints: (builder) => ({
    createStripeIntent: builder.mutation<
      { clientSecret: string | null; amount: number; free?: boolean },
      PaymentIntentPayload
    >({
      query: (params) => ({
        url: `stripe/create-payment-intent`,
        method: 'POST',
        body: params
      })
    }),
    getStripeIntent: builder.mutation<
      { payment_intent: { clientSecret: string; charge: string; last4: string } },
      { payment_intent: string; location_id: number }
    >({
      query: (params) => ({
        url: `stripe/get-payment-intent`,
        method: 'POST',
        body: params
      })
    })
  })
});

export const { useCreateStripeIntentMutation, useGetStripeIntentMutation } = stripeApi;
